export enum StreamType {
    WEBRTC = "webrtc",
    IOS_WEBRTC = "iosWebrtc",
    WECHAT_WEBRTC = "wechatWebrtc",
    RTMP = "rtmp",
}

export interface PageDto {
    // eslint-disable-next-line
    data: any;

    total: number;

    offset: number;

    limit: number;
}

export type TalkUserStatus = "down" | "waiting" | "up";

export interface RoomMemberItem {
    userId: number;

    userName: string;
}

export interface RoomMemberDto {
    id: number;

    roomId: number;

    userId: number;

    userName: string;

    /**
     * 角色
     */
    role: string;

    /**
     * 是否在线
     */
    isOnline: boolean;

    /**
     * 最新进入时间
     */
    lastEnterAt: number;

    /**
     * 禁言
     */
    isMute: boolean;

    /**
     * 拉黑
     */
    isBlock: boolean;

    /**
     * 是否虚拟用户
     */
    isVirtual: boolean;

    groupName: string;

    groupNo: string;

    talkStatus?: TalkUserStatus;

    talkerSupport: string;
}
